export default {
  data() {
      return {

      }
  },
  methods: {
      notify(pType, pTitle, pMessage) {
          this.$notify({
              group: 'main',
              type: pType,
              title: pTitle,
              text: pMessage,
          });
      }
  }
}
